module.exports = __webpack_public_path__ + "img/29.b6ada86a.svg";